module.exports = __webpack_public_path__ + "small-down.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/small-down.svg?color1=%23333333&color2=
// module id = 2211
// module chunks = 67